<template>
  <div class="container mx-auto px-4 md:py-8 sm:container sm:mx-auto">
    <div class="maintitlecont">
      <h1 class="maintitle font-bold">{{$t('checkout')}}</h1>
    </div>
    <HorizontalStepsDiagram :steps="steps" :activeStep="activeStep" />
    <div class="flex space-x-6 wrapper">
      <CosulMeu v-if="activeStep === 1" :nextStep="nextStep"/>
      <DetaliiUtilizator v-if="activeStep === 2" :checkoutOrder="checkoutOrder" :smsInfo="smsInfo"/>
      <div class="cols-grid-1 rcol pay-info" :class="{ mtop: activeStep === 1 }">
        <div
          style="
            border: 2px solid #5f2eea;
            filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
            padding: 20px;
            background-color: #ffffff;
          "
        >
          <loading
            color="#4e46dc"
            v-model:active="loadingPay"
            transition="disappear"
            :can-cancel="false"
            :is-full-page="true"
          />
          <div
            class="mb-2"
            style="
              display: flex;
              justify-content: space-between;
              font-weight: bold;
            "
          >
            <div>{{$t('total_payment')}}:</div>
            <div>{{ this.getTotalTaxesValue }} Lei</div>
          </div>
          <div
            style="
              padding: 0 10px;
              text-align: left;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: start;
            "
          >
            <div class="cart-btns" style="text-align: center">
              <div v-if="activeStep === 1">
                <button
                  :disabled="getCartTickets.length == 0"
                  @click="nextStep"
                  class="mt-3 mb-2 bg-primary-muzeu text-white font-bold px-2 py-1 flex align-center"
                  style="
                    border-radius: 20px;
                    padding: 10px 20px 8px;
                    display: block;
                    width: 100%;
                    justify-content: center;
                  "
                >
                  <span class="mr-1">{{$t('next_step')}}</span>
                </button>
              </div>
              <div v-if="activeStep === 2">
                <button
                  :disabled="getUser == null && getGuestData == null"
                  @click="checkoutOrder"
                  class="mt-3 mb-2 bg-primary-muzeu text-white font-bold px-2 py-1 flex align-center"
                  style="
                    border-radius: 20px;
                    padding: 10px 20px 8px;
                    display: block;
                    width: 100%;
                    justify-content: center;
                  "
                >
                  <span class="mr-1">{{$t('pay')}}</span>
                </button>
              </div>
              <router-link to="/" class="other hidden lg:block">
                <button
                  class="mt-3 font-bold px-2 py-1 flex align-center"
                  style="
                    border-radius: 20px;
                    padding: 10px 20px 8px;
                    border: 1px solid #5f2eea;
                    display: block;
                    width: 100%;
                    justify-content: center;
                  "
                >
                  <span class="mr-1">{{$t('continue_shopping')}}</span>
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HorizontalStepsDiagram from "../components/HorizontalStepsDiagram.vue";
import CosulMeu from "../components/CosulMeu.vue";
import DetaliiUtilizator from "../components/DetaliiUtilizator.vue";
import Loading from "vue-loading-overlay";
const config = require("../config");

export default {
  components: {
    HorizontalStepsDiagram,
    CosulMeu,
    DetaliiUtilizator,
    Loading,
  },
  data() {
    return {
      loadingPay: false,
      steps: [
        { title: this.$t("my_cart") },
        { title: this.$t("user_details") },
        { title: this.$t("payment") },
      ],
      activeStep: 1,
      smsInfo: {
        accept: true,
        price: 0,
        currency: "lei"
      }
    };
  },
  computed: {
    ...mapGetters([
      "getCart",
      "getUser",
      "getTotalTaxesValue",
      "getInstanceIds",
      "getCartTickets",
      "getGuestData",
      "getSmsTax",
      "getAcceptSms"
    ]),
  },
  methods: {
    nextStep() {
      this.activeStep++;
    },
    async checkoutOrder() {
      this.loadingPay = true;
      let data = {
        transactions: [
          {
            instanceIds: this.getInstanceIds,
            deliveryId: 2,
            paymentId: 1,
          },
        ],
        sendSms: this.getAcceptSms
      };
      if (this.getUser == null) {
        data.newUser = {
          firstName: this.getGuestData.firstname,
          lastName: this.getGuestData.lastname,
          email: this.getGuestData.email,
          phone: this.getGuestData.phone.trim().replace(/^\+/, "00"),
          newsletter: this.getGuestData.newsletter,
          guest: true
        }
      }
      const response = await this.$store.dispatch("checkout", data);
      if (response.result == 1) {
        if (response.data.cardTransaction != null) {
          window.location.href = `${config.serverUrl}/spring/transaction/euplatesc/send?tId=${response.data.cardTransaction}`;
        } else if (response.data.transactionPrice == 0){
          window.location.href = `/payment-response?tcode=${response.data.transactionCode}&code=1`;
        }
      } else {
        console.log(response.result);
      }
      this.loadingPay = false;
    },
  },
  async created() {
    this.$store.dispatch("fetchUser");
    this.taxes = await this.$store.dispatch('getTaxes');
    this.smsInfo.price = this.getSmsTax;
  },
};
</script> 

<style scoped>

button:disabled {
  background-color: #808080;
}

</style>